import { Tooltip } from "@mui/material";

export const getItemLevelColumns = () => [
  {
    field: "Item_Nbr",
    headerName: "SKU",
    width: 70,
    renderCell: (params) => <span>{params.value.slice(0, 6)}</span>,
  },
  {
    field: "short_description",
    headerName: "Item Description",
    sortable: true,
    width: 130,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "vendor_name",
    headerName: "Vendor",
    width: 100,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
];
